import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { MATERIAL_STATES, MATERIAL_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import { Title } from 'components/Misc/Typography';

const Material = ({ material }) => {
	// Find status info
	const status = useMemo(() => MATERIAL_STATES.find(status => status.value === material.status), [material.status]);
	const type = useMemo(() => MATERIAL_TYPES.find(type => type.value === material.type), [material.type]);

	return (
		<Link
			to={`/materials/${material.id}`}
			className="pt-3 px-4 pb-3 space-y-2 bg-white dark:bg-neutral-800 rounded-lg hover:ring focus:ring ring-amber-500 cursor-pointer transition-all"
		>
			<Title
				title={material.title}
				subtitle={material.subject.title}
			/>

			<div className="flex space-x-2">
				{/* Material's type */}
				<Pill
					name={type?.text}
				/>

				{/* Show state if not visible */}
				<Show if={material.status !== 'visible'}>
					<Pill
						name={status?.text}
						theme={status?.theme}
					/>
				</Show>
			</div>
		</Link>
	);
};

export default Material;
